/* eslint-disable */
import {
  Chip,
  createStyles,
  Input,
  MenuItem,
  Theme,
  withStyles,
} from "@material-ui/core";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Component } from "react";
import { connect } from "react-redux";
import { Select as SelectMultiple } from "@material-ui/core";

import {
  getAllProperties,
  edit_Properties,
  edit_Properties_list,
} from "../../../../utils/store/actions/users.actions";
import { B4FText } from "../../B4FFields/B4FText";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    accordion: {
      borderRadius: "10px",
      boxShadow: "none",
    },
  });
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
class InputProperties extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }


  // handlechange property list
  handleChangePropertyList = (event: any, property: any) => {
    let propArray: any;
    if (Array.isArray(property.values)) {
      propArray = property.values;
    } else {
      propArray = [""];
    }
    if (propArray.includes(event.props?.value)) {
      propArray.splice(propArray.indexOf(event.props?.value));
    } else {
      propArray.push(event.props?.value);
    }

    this.props
      .edit_Properties_list({
        key: property.key || event.props?.id,
        values: propArray,
      })
      .then(() => this.props.getAllProperties());
  };
  handleChangeProperty(e: any, prop: any) {
    this.props.edit_Properties({
      key: prop.key,
      value: e.target
        ? e.target.checked !== undefined
          ? e.target.checked
          : e.target.value
        : e.value,
    });
  }
  
  render() {
    const { classes, t } = this.props;
    return (
      <Accordion
      className={classes.accordion}
      style={{ flexDirection: "column" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#AE0064" }} />}
        aria-controls="panel2a-content"
        id="modules"
      >
        <Typography className={classes.heading}>{"Inputs"}</Typography>
      </AccordionSummary>
      <AccordionDetails style={{ flexWrap: "wrap" }}>
        <List className={classes.root}>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) => {
              return (
                property.key === "BANKS" && (
                  <FormControl id="propertyBank">
                    <FormLabel>{t(property.key)}</FormLabel>
                    <SelectMultiple
                      labelId="demo-mutiple-chip-label"
                      id="banks"
                      multiple
                      value={property.values || [""]}
                      onChange={(e: any, value: any) => {
                        this.handleChangePropertyList(value, property);
                      }}
                      renderValue={(selected: any) => (
                        <div className={classes.chips}>
                          {selected.map((value: any) => {
                            const label =
                              this.props.Surveys?.enumsFiltered &&
                              this.props.Surveys.enumsFiltered[
                                "banks"
                              ]?.find((obj: any) => obj.key === value)
                                ?.label;
                            return (
                              <Chip
                                style={{ maxWidth: "200px" }}
                                key={value}
                                label={
                                  label
                                    ? this.props.t("ENUMS." + label)
                                    : ""
                                }
                                className={classes.chip}
                              />
                            );
                          })}
                        </div>
                      )}
                      input={<Input id="select-multiple-chip" />}
                      MenuProps={MenuProps}
                    >
                      {this.props.Surveys?.enumsFiltered &&
                        this.props.Surveys?.enumsFiltered["banks"]?.map(
                          (obj: any) => {
                            return (
                              <MenuItem
                                id="banks"
                                key={obj.key}
                                value={obj.key}
                              >
                                {this.props.t("ENUMS." + obj?.label)}
                              </MenuItem>
                            );
                          }
                        )}
                    </SelectMultiple>
                  </FormControl>
                )
              );
            }
          )}
        </List>
        <List className={classes.root}>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) => {
              return (
                property.key === "ENGAGEMENT_LETTER_NATURES" && (
                  <FormControl id="propertyEngagementNature">
                    <FormLabel>{t(property.key)}</FormLabel>
                    <SelectMultiple
                      labelId="demo-mutiple-chip-label"
                      multiple
                      value={property.values || [""]}
                      onChange={(e: any, value: any) => {
                        this.handleChangePropertyList(value, property);
                      }}
                      renderValue={(selected: any) => (
                        <div className={classes.chips}>
                          {selected.map((value: any) => {
                            const label =
                              this.props.Surveys?.enumsFiltered &&
                              this.props.Surveys?.enumsFiltered[
                                "engagement-nature"
                              ]?.find((obj: any) => obj.key === value)
                                ?.label;
                            return (
                              <Chip
                                style={{ maxWidth: "200px" }}
                                key={value}
                                label={
                                  label
                                    ? this.props.t("ENUMS." + label)
                                    : ""
                                }
                                className={classes.chip}
                              />
                            );
                          })}
                        </div>
                      )}
                      input={<Input id="select-multiple-chip" />}
                      MenuProps={MenuProps}
                    >
                      {this.props.Surveys?.enumsFiltered &&
                        this.props.Surveys?.enumsFiltered[
                          "engagement-nature"
                        ]?.map((obj: any) => {
                          return (
                            <MenuItem
                              id="banks"
                              key={obj.key}
                              value={obj.key}
                            >
                              {this.props.t("ENUMS." + obj?.label)}
                            </MenuItem>
                          );
                        })}
                    </SelectMultiple>
                  </FormControl>
                )
              );
            }
          )}
        </List>
        </AccordionDetails>
        <AccordionDetails>
        <List className={classes.root}>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) =>
              property.key === "DPO_EMAIL_ADDRESS" && (
                <FormControl id="customerSupportEmail">
                  <FormLabel>{t(property.key)}</FormLabel>
                  <B4FText
                    value={this.state.customerEmail || property.value}
                    onChange={(e: any) => {
                      this.setState({ customerEmail: e.value });
                    }}
                    onBlur={(e: any) => {
                      this.handleChangeProperty(e, property);
                    }}
                    label=""
                    id="email"
                    key="email"
                    isDisabled={false}
                    isRequired={false}
                    visible={true}
                  />
                </FormControl>
              )
          )}
        </List>
      </AccordionDetails>
      <AccordionDetails>
        <List className={classes.root}>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) =>
              property.key === "DPO_PHONE_NUMBER" && (
                <FormControl id="customerPhoneNumber">
                  <FormLabel>{t(property.key)}</FormLabel>
                  <B4FText
                    value={
                      this.state.customerPhoneNumber || property.value
                    }
                    label=""
                    onChange={(e: any) => {
                      this.setState({
                        customerPhoneNumber: e.value,
                      });
                    }}
                    onBlur={(e: any) => {
                      this.handleChangeProperty(e, property);
                    }}
                    id="phone"
                    key="phone"
                    isDisabled={false}
                    isRequired={false}
                    visible={true}
                  />
                </FormControl>
              )
          )}
        </List>
      </AccordionDetails>
      <AccordionDetails>
        <List className={classes.root}>
          {(this.props.Users?.get_properties || [])?.map(
            (property: any) =>
              property.key === "TENANT_CONTACT_INFO" && (
                <FormControl id="customerMifidInformation" key={property.key}>
                  <FormLabel>{t(property.key)}</FormLabel>
                  <B4FText
                    value={
                      this.state.customerMifidInformation || property.value
                    }
                    label=""
                    onChange={(e: any) => {
                      this.setState({
                        customerMifidInformation: e.value,
                      });
                    }}
                    onBlur={(e: any) => {
                      this.handleChangeProperty(e, property);
                    }}
                    id="customerMifidInformation"
                    key="textarea"
                    isDisabled={false}
                    isRequired={false}
                    visible={true}
                  />
                </FormControl>
              )
          )}
        </List>
      </AccordionDetails>
    </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllProperties,
  edit_Properties,
  edit_Properties_list,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(InputProperties)));
